import type { BackgroundColorToken } from '@canvas/constants/colors/tokens-types';
import { getTelepointerColorTokenForCollaborator } from '@canvas/constants/get-color-value';
import type { Identity } from '@canvas/model/identity';

const COLORS_TO_OMIT = new Set<BackgroundColorToken>([
  'color.background.accent.blue.bolder'
]);

export type FieldEntryGrouping =
  | {
      fieldId: string;
      entryId: string;
    }
  | {
      fieldId: string;
    }
  | {
      entryId: string;
    };

export interface Participant {
  identity: Identity;
  colorToken: BackgroundColorToken;
}

export const createParticipantFromIdentity = (
  identity: Identity,
  clientId: number
): Participant => {
  return {
    identity,
    colorToken: getTelepointerColorTokenForCollaborator(clientId, COLORS_TO_OMIT)
  };
};
